import { Button, Card, Col, Row, Typography } from "antd";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { howItWorks } from "../landingData";

const { Title, Paragraph } = Typography;

export function HowItWorksSection() {
  const navigate = useNavigate();

  return (
    <section id="how-it-works" className="landing-section">
      <Title level={2}>So Simple, You'll Wonder Why You Waited</Title>
      <Paragraph className="landing-section-subtitle">
        Most owners are up and running quickly. No tech skills required.
      </Paragraph>

      <Row gutter={[24, 24]}>
        {howItWorks.map((item) => {
          const Icon = item.icon;

          return (
            <Col xs={24} md={8} key={item.step}>
              <Card className="landing-step-card">
                <div className="landing-step-number">{item.step}</div>
                <Icon size={32} />
                <Title level={3}>{item.title}</Title>
                <Paragraph>{item.description}</Paragraph>
              </Card>
            </Col>
          );
        })}
      </Row>

      <Button
        type="primary"
        size="large"
        className="landing-primary-button landing-section-button"
        onClick={() => navigate("/register")}
      >
        Start Your Free Trial <ArrowRight size={18} />
      </Button>
      <Paragraph type="secondary" className="landing-note">
        14 days free, then only $149/month for unlimited everything
      </Paragraph>
    </section>
  );
}